import api from "axios";

export const getAlertList = async () => {
  return api
    .get("/followcar/alerts", {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => res?.data?.payload ?? [])
    .catch((err) => err);
};

export const deleteAlertItem = async (id) => {
  return api
    .delete(`/followcar/delete/${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => res)
    .catch((err) => err);
};

export const saveAlertItem = async (data) => {
  return api
    .post("/followcar/save", data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => res)
    .catch((err) => err);
};
